module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Page Not Found","body":"The page you requested could not be found."}}')
  delete Component.options._Ctor
}
